<template>
  <div v-if="visible" ref="iframe_dialog" class="iframe_dialog">
    <div
      class="iframe_dialog__main"
      :style="{
        width: `${width}px`,
        height: `${height}px`
      }"
    >
      <img
        src="~@/assets/images/vip/close.png"
        alt=""
        class="iframe_dialog_close"
        @click="cancel"
      />
      <h3>{{ title }}</h3>
      <iframe
        v-if="url"
        :src="url"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="no"
      ></iframe>
    </div>
    <div class="iframe_dialog__mask"></div>
  </div>
</template>

<script>
export default {
  name: 'IframeDialog',
  props: {
    width: {
      type: Number,
      default: 620
    },
    height: {
      type: Number,
      default: 680
    },
    url: {
      type: String,
      default: '//www.baidu.com'
    },
    title: {
      type: String,
      default: '会员权益对比'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe_dialog {
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  h4 {
    margin: 31px 0 25px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #222222;
    line-height: 24px;
    text-align: center;
  }

  &__main {
    padding: 30px 10px;
    background: #fff;
    border-radius: 8px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;

    .iframe_dialog_close {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 20px;
      right: 20px;
    }

    h3 {
      margin-bottom: 25px;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 18px;
      color: #222222;
      line-height: 24px;
      text-align: center;
    }

    iframe {
      flex: 1;
      width: 100%;
    }
  }

  &__mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}
</style>
